import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=251f8298&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=251f8298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f8298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('251f8298')) {
      api.createRecord('251f8298', component.options)
    } else {
      api.reload('251f8298', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=251f8298&scoped=true&", function () {
      api.rerender('251f8298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Sidebar.vue"
export default component.exports